const NormalSideInput = ({title,placeHolder,name,onChange,value,onBlur,onInput,maxLength}) => {
    return(
        <div>
            <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-1">{title}</p>
            <input 
            name={name} onChange={onChange}value={value}  onBlur={onBlur} onInput={onInput} maxLength={maxLength}
            className="h-[35px]   w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder={placeHolder} />
        </div>
    )
}

export default NormalSideInput;